'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ltr = 'ltr';
var rtl = 'rtl';
var left = 'left';
var right = 'right';

// Tokens follow one of the following patterns:
// (1) ${MyStringToken} for standard user-defined tokens
// (2) ${obj.field} for argument-based tokens
// (3) ${field:obj} for argument-based tokens (equivalent to above)
var tokenPattern = /^(.*?)\$\{(((.+?)\.(.+?))|((.+?):(.+?))|(.+?))\}(.*)$/;

var I18n = function () {
    function I18n(i18n) {
        (0, _classCallCheck3.default)(this, I18n);

        this._i18n = i18n;
        this.DIR_LTR = ltr;
        this.DIR_RTL = rtl;
    }

    (0, _createClass3.default)(I18n, [{
        key: 'getLocale',
        value: function getLocale() {
            return this._i18n.locale;
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage() {
            return this._i18n.language;
        }
    }, {
        key: 'getGoogleLanguage',
        value: function getGoogleLanguage() {
            return this._i18n.locale_google;
        }
    }, {
        key: 'getFacebookLanguage',
        value: function getFacebookLanguage() {
            return this._i18n.locale_fb;
        }
    }, {
        key: 'getDir',
        value: function getDir() {
            return this._i18n.dir;
        }
    }, {
        key: 'getReverseDir',
        value: function getReverseDir() {
            return this._i18n.dir === rtl ? ltr : rtl;
        }
    }, {
        key: 'isRtlDir',
        value: function isRtlDir() {
            return this._i18n.dir === rtl;
        }
    }, {
        key: 'getAlign',
        value: function getAlign() {
            return this._i18n.dir === rtl ? right : left;
        }
    }, {
        key: 'getReverseAlign',
        value: function getReverseAlign() {
            return this._i18n.dir === rtl ? left : right;
        }
    }, {
        key: 'l',
        value: function l() {
            var localizedStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var defaultLocale = arguments[1];

            return localizedStr[this._i18n.locale] || localizedStr[defaultLocale] || '';
        }
    }, {
        key: 'get',
        value: function get(token, _default) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var value = this._i18n.tokens[token] || _default;

            return this.expandMultiLine(value, params);
        }
    }, {
        key: 'expandMultiLine',
        value: function expandMultiLine(value, params) {
            var parts = value.split('\n');

            var expandedParts = [];
            for (var i = 0, l = parts.length; i < l; ++i) {
                expandedParts.push(this.expand(parts[i], params));
            }

            return expandedParts.join('\n');
        }
    }, {
        key: 'expand',
        value: function expand(value, params) {
            var groups = value.match(tokenPattern);

            if (!groups) {
                return value;
            }

            var numGroups = groups.length;
            if (numGroups !== 11) {
                throw new Error('Regexp error [' + value + '|' + numGroups + ']');
            }

            if (typeof groups[9] !== 'undefined' && groups[9].length !== 0) {
                // (1)
                return this.expandMultiLine('' + groups[1] + this.get(groups[9], params) + groups[10], params);
            }

            var objName;
            var fieldName;
            if (typeof groups[3] !== 'undefined') {
                // (2)
                objName = groups[4];
                fieldName = groups[5];
            } else if (typeof groups[6] !== 'undefined') {
                // (3)
                objName = groups[8];
                fieldName = groups[7];
            } else {
                throw new Error('Regexp error [' + value + ']');
            }

            var value = '';
            var obj = params[objName];
            if (typeof obj !== 'undefined') {
                var field = obj[fieldName];
                if (typeof field !== 'undefined') {
                    // Implicit support for i18n fields
                    value = field[this._i18n.locale];
                    if (typeof value === 'undefined') {
                        value = field;
                    }
                } else if (typeof obj.getValue !== 'undefined') {
                    value = obj.getValue(fieldName);
                }
            }

            return this.expandMultiLine('' + groups[1] + value + groups[10], params);
        }
    }]);
    return I18n;
}();

exports.default = I18n;